export default [
  'Aeroplane',   'Bicycle', 'Bird',  'Boat',      'Bottle', 'Bus',         'Car',   'Cat',  'Chair', 'Cow',
  'Diningtable', 'Dog',     'Horse', 'Motorbike', 'Person', 'Pottedplant', 'Sheep', 'Sofa', 'Train', 'Tvmonitor'
];